module.exports = __webpack_public_path__ + "img/icon-close.d87fb7cf.svg";